import * as React from 'react';
import SlickSlider from 'react-slick';

import styles from './Slider.scss';
import stylesVariables from '../../_variables.scss';
import { StatisticsPageLocale } from '../statisticsPage.locale';
import Graph from '../../../containers/Graph/Graph';
import { Query } from '../../../GraphQL';

interface SliderProps {
  locale: StatisticsPageLocale;
  traffics: Query['traffics'][];
  hydrated: boolean;
  setActiveGraph: (index: number) => void;
  sliderRef: React.RefObject<SlickSlider>;
}

const Slider: React.SFC<SliderProps> = ({
  locale,
  traffics,
  hydrated,
  setActiveGraph,
  sliderRef,
}) => (
  <SlickSlider
    key={hydrated ? 'hydratedSlider' : 'ssrSlider'}
    ref={sliderRef}
    {...{
      beforeChange: (oldIndex, newIndex) => setActiveGraph(newIndex),
      accessibility: true,
      dots: false,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      initialSlide: 1,
      centerMode: true,
      centerPadding: hydrated ? '33%' : '20%',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: parseInt(stylesVariables['xl-breakpoint'], 10),
          settings: {
            centerPadding: '20%',
          },
        },
        {
          breakpoint: parseInt(stylesVariables['lg-breakpoint'], 10),
          settings: {
            centerPadding: '18%',
          },
        },
        {
          breakpoint: parseInt(stylesVariables['md-breakpoint'], 10),
          settings: {
            centerPadding: '15%',
          },
        },
        {
          breakpoint: parseInt(stylesVariables['sm-breakpoint'], 10),
          settings: {
            centerPadding: '10%',
          },
        },
      ],
    }}
    className={styles.slider}
  >
    {locale.graphs.map((graph, index) => (
      <div key={graph.periodLength} className={styles.graphContainer}>
        <Graph title={locale.graphsTitle} data={traffics[index]} period={graph.periodText} />
      </div>
    ))}
  </SlickSlider>
);

export default Slider;



// WEBPACK FOOTER //
// /www/client/src/components/StatisticsPage/Slider/Slider.tsx